var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ordering-person-form',{ref:"orderingPersonRef",attrs:{"query-params":`card_order=${_vm.getActiveCardOrderId}`,"form-data-object":_vm.getActiveFormOrderingPerson},on:{"form-success":_vm.handleFormSuccess,"request-update":_vm.reloadActiveFormData,"is-dirty":function($event){return _vm.$emit('is-dirty')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }